// extracted by mini-css-extract-plugin
export default {"wrapper":"categories_wrapper__wom-j","header":"categories_header__I2I25","btnWrapper":"categories_btnWrapper__MzCDS"};